import React from 'react'
import {Button, Flex, Text} from '../../vanilla'
import {CTAButton} from '../../vanilla/components/CTAButton'
import {CTA} from '../../types/cms'
import {CloseIcon} from '../icons'
import VisuallyHidden from '@reach/visually-hidden'
import {bannerContainer, bannerContent} from './styles.css'

interface NotificationBannerContent {
  text: {
    title: string
    description: string
  }
  cta: CTA
}

interface BannerProps {
  content: NotificationBannerContent
  onCTAClicked: () => void
  onDismiss: () => void
}

const Banner = ({content, onCTAClicked, onDismiss}: BannerProps) => {
  const {text, cta} = content

  return (
    <Flex className={bannerContainer} data-test-selector="notification-banner">
      <Flex
        width="full"
        justify="space-between"
        align="center"
        flexWrap="wrap"
        gap="16px"
        style={{maxWidth: '1200px', margin: '0 auto'}}
      >
        <Flex className={bannerContent}>
          <Text variant="heading1" color="black" data-test-selector="banner-title">
            {text.title}
          </Text>
          <Text variant="text3" color="black" data-test-selector="banner-description">
            {text.description}
          </Text>
        </Flex>
        <Flex align="center" gap="24px">
          <CTAButton
            cta={cta}
            variant="primary"
            onClickCapture={onCTAClicked}
            data-test-selector="banner-cta-button"
          >
            {cta.ctaText}
          </CTAButton>
        </Flex>
      </Flex>
      <Button
        variant="unstyled"
        width="44px"
        onClick={onDismiss}
        data-test-selector="banner-close-button"
      >
        <VisuallyHidden>Close</VisuallyHidden>
        <CloseIcon boxSize="24px" />
      </Button>
    </Flex>
  )
}

export default Banner
